import { AbortController } from "node-abort-controller"
import { CANCEL } from "redux-saga"

import CONFIG from "core/config"
import fetch from "core/fetch"

export function getLastPaymentDetails(userId) {
  const controller = new AbortController()
  const options = {
    signal: controller.signal,
    url: `${CONFIG.gatewayHost}/v3/payments/customers/${userId}/last`,
    method: "GET",
  }
  const promise = fetch(options)
  promise[CANCEL] = () => controller.abort()

  return promise
}

export function getCurrentPaymentMethodDetails(userId) {
  const controller = new AbortController()
  const options = {
    signal: controller.signal,
    url: `${CONFIG.gatewayHost}/v3/payment-methods/customers/${userId}/current`,
    method: "GET",
  }
  const promise = fetch(options)
  promise[CANCEL] = () => controller.abort()

  return promise
}

export function getPaymentMethodUpdateStatus(userId, processId) {
  const options = {
    url: `${CONFIG.gatewayHost}/v3/payment-methods/customers/${userId}/manage/${processId}`,
    method: "GET",
  }
  const promise = fetch(options)

  return promise
}

export function updatePaymentMethod(userId, data) {
  const options = {
    url: `${CONFIG.gatewayHost}/v3/payment-methods/customers/${userId}/manage`,
    method: "POST",
    data,
  }
  const promise = fetch(options)

  return promise
}

export default {
  getLastPaymentDetails,
  getCurrentPaymentMethodDetails,
  getPaymentMethodUpdateStatus,
  updatePaymentMethod,
}
